module.exports = __webpack_public_path__ + "static/media/qrCode-white.4a109ae7.svg";